import React, { useState } from "react";
import { Button, FormFieldSet } from "../../../../components";
import { EmploymentType, Gender } from "../../../../assets/data/enumData";

const FillDetailsApplicant = ({
  formData,
  errors,
  handleChange,
  setStatus,
  isFetchedEntity,
  onboardingId,
}) => {
  return (
    <div>
      <div className="m-4 ">
        {!onboardingId && (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <FormFieldSet
              type="employeesSortedOnboarding"
              title="Select Employee"
              placeholder="Select Employee"
              // options={employeeOptions}
              value={formData.employee}
              onChange={(value) => handleChange("employee", value)}
              error={errors.employee}
              showSearch
            />
          </div>
        )}

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <FormFieldSet
            type="text"
            title="First Name"
            placeholder="Enter First Name"
            value={formData.firstName}
            onChange={(value) => handleChange("firstName", value)}
            error={errors.firstName}
            disabled={true}
          />
          <FormFieldSet
            type="text"
            title="Middle Name"
            placeholder="Enter Middle Name"
            value={formData.middleName}
            onChange={(value) => handleChange("middleName", value)}
            error={errors.middleName}
            disabled={true}
          />
          <FormFieldSet
            type="text"
            title="Last Name"
            placeholder="Enter Last Name"
            value={formData.lastName}
            onChange={(value) => handleChange("lastName", value)}
            error={errors.lastName}
            disabled={true}
          />
          <FormFieldSet
            type="select"
            title={"Gender"}
            placeholder="Select Gender"
            options={Gender}
            value={formData.gender}
            onChange={(value) => handleChange("gender", value)}
            error={errors.gender}
            disabled={true}
          />
          <FormFieldSet
            type="select"
            title={"Employment Type"}
            placeholder="Select Employment Type"
            value={formData.employmentType}
            onChange={(value) => handleChange("employmentType", value)}
            options={EmploymentType}
            error={errors.employmentType}
            disabled={true}
          />
          <FormFieldSet
            type="text"
            title="Employee ID"
            placeholder="Enter Employee ID"
            value={formData.employeeId}
            onChange={(value) => handleChange("employeeId", value)}
            error={errors.employeeId}
            disabled={true}
          />
          <FormFieldSet
            title="Job Title"
            placeholder="Select Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            disabled={true}
          />
          <FormFieldSet
            type="text"
            title="Email Address"
            placeholder="Enter Email Address"
            value={formData.email}
            onChange={(value) => handleChange("email", value)}
            error={errors.email}
            disabled={true}
          />
          <FormFieldSet
            type="text"
            title="Alternate Email Address"
            placeholder="Enter Alternate Email Address"
            value={formData.alternateEmail}
            onChange={(value) => handleChange("alternateEmail", value)}
            error={errors.alternateEmail}
            disabled={true}
          />
          <FormFieldSet
            type="datepicker"
            title="Date of Birth"
            placeholder="Select Date of Birth"
            value={formData.dateOfBirth}
            onChange={(value) => handleChange("dateOfBirth", value)}
            error={errors.dateOfBirth}
            disabled={true}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title="Social Security Number"
            placeholder="Enter Social Security Number"
            value={formData.socialSecurityNumber}
            onChange={(value) => handleChange("socialSecurityNumber", value)}
            error={errors.socialSecurityNumber}
            disabled={true}
          />
          <FormFieldSet
            type="phone"
            title={"Contact Number"}
            placeholder="Enter Contact"
            value={formData.contactNumber}
            code={formData.contactNumberCountryCode}
            onChange={(fullValue, details) => {
              handleChange(`formData.contactNumber`, details.number);
              handleChange(
                `formData.contactNumberCountryCode`,
                details.countryCode,
              );
            }}
            disabled={true}
          />
          <FormFieldSet
            type="datepicker"
            title="Date of Joining"
            placeholder="Select Date of Joining"
            value={formData.dateOfJoining}
            onChange={(value) => handleChange("dateOfJoining", value)}
            error={errors.dateOfJoining}
            disabled={true}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title="Onboarding Code"
            placeholder="Autogenerated"
            value={formData.onboardingCode}
            onChange={(value) => handleChange("onboardingCode", value)}
            error={errors.onboardingCode}
            disabled={true}
          />
          <div className="col-span-2 lg:col-span-3">
            <FormFieldSet
              type="text"
              title="Full Address"
              placeholder="Enter Full Address"
              value={formData.fullAddress}
              onChange={(value) => handleChange("fullAddress", value)}
              error={errors.fullAddress}
              disabled={true}
            />
          </div>
          <FormFieldSet
            type="countriesUsAndCanada"
            title={"Country"}
            placeholder="Select Country"
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            disabled={true}
          />
          <FormFieldSet
            showSearch
            type="states"
            title={"State"}
            keyname={"states"}
            placeholder="Select State"
            value={formData.state}
            onChange={(value) => handleChange("state", value)}
            error={errors.state}
            parentValue={{
              country: formData.country.value ?? formData.country,
            }}
            disabled={true}
          />
          <FormFieldSet
            type="cities"
            showSearch
            keyname={"cities"}
            title={"City"}
            placeholder="Select City"
            value={formData.city}
            onChange={(value) => handleChange("city", value)}
            error={errors.city}
            parentValue={{
              country: formData.country.value ?? formData.country,
              state: formData?.state?.value || formData.state,
            }}
            disabled={true}
            // parentId={countryId}
          />
          <FormFieldSet
            type="text"
            title="Zip Code"
            placeholder="Enter Zip Code"
            value={formData.zipCode}
            onChange={(value) => handleChange("zipCode", value)}
            error={errors.zipCode}
            disabled={true}
          />
          <div className="col-span-2 lg:col-span-3">
            <FormFieldSet
              type="textArea"
              title="Comments"
              placeholder="Enter Comments"
              value={formData.comments}
              onChange={(value) => handleChange("comments", value)}
              error={errors.comments}
              rows={5}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FillDetailsApplicant;
